import afZA from './af-ZA.js';
import arAE from './ar-AE.js';
import bgBG from './bg-BG.js';
import csCZ from './cs-CZ.js';
import daDK from './da-DK.js';
import deAT from './de-AT.js';
import deCH from './de-CH.js';
import deDE from './de-DE.js';
import elCY from './el-CY.js';
import elGR from './el-GR.js';
import enGB from './en-GB.js';
import enUS from './en-US.js';
import esES from './es-ES.js';
import etEE from './et-EE.js';
import fiFI from './fi-FI.js';
import frBE from './fr-BE.js';
import frFR from './fr-FR.js';
import frLU from './fr-LU.js';
import gaIE from './ga-IE.js';
import heIL from './he-IL.js';
import hrHR from './hr-HR.js';
import huHU from './hu-HU.js';
import hyAM from './hy-AM.js';
import itIT from './it-IT.js';
import jaJP from './ja-JP.js';
import ltLT from './lt-LT.js';
import mtMT from './mt-MT.js';
import nbNO from './nb-NO.js';
import nlNL from './nl-NL.js';
import plPL from './pl-PL.js';
import ptPT from './pt-PT.js';
import roRO from './ro-RO.js';
import ruRU from './ru-RU.js';
import skSK from './sk-SK.js';
import slSI from './sl-SI.js';
import svSE from './sv-SE.js';
import trCY from './tr-CY.js';
import trTR from './tr-TR.js';
import ugCN from './ug-CN.js';
import uzUZ from './uz-UZ.js';
import zhCN from './zh-CN.js';
import zhTW from './zh-TW.js';

const elementLocales = {
    "af-ZA": afZA,
    "ar-AE": arAE,
    "bg-BG": bgBG,
    "cs-CZ": csCZ,
    "da-DK": daDK,
    "de-AT": deAT,
    "de-CH": deCH,
    "de-DE": deDE,
    "el-CY": elCY,
    "el-GR": elGR,
    "en-GB": enGB,
    "en-US": enUS,
    "es-ES": esES,
    "et-EE": etEE,
    "fi-FI": fiFI,
    "fr-BE": frBE,
    "fr-FR": frFR,
    "fr-LU": frLU,
    "ga-IE": gaIE,
    "he-IL": heIL,
    "hr-HR": hrHR,
    "hu-HU": huHU,
    "hy-AM": hyAM,
    "it-IT": itIT,
    "ja-JP": jaJP,
    "lt-LT": ltLT,
    "mt-MT": mtMT,
    "nb-NO": nbNO,
    "nl-NL": nlNL,
    "pl-PL": plPL,
    "pt-PT": ptPT,
    "ro-RO": roRO,
    "ru-RU": ruRU,
    "sk-SK": skSK,
    "sl-SI": slSI,
    "sv-SE": svSE,
    "tr-CY": trCY,
    "tr-TR": trTR,
    "ug-CN": ugCN,
    "uz-UZ": uzUZ,
    "zh-CN": zhCN,
    "zh-TW": zhTW
};

export default elementLocales;